import * as React from 'react'

import { useTranslation } from 'react-i18next'

import { Text } from '@chakra-ui/react'

import {
  ModalView,
  PrimaryButton,
  TertiaryButton,
  toaster,
} from '@enechain/ecloud-designsystem'

import { useResetMfa } from '~/pages/Members/hooks/useResetMfa'

type Props = {
  name: string
  memberId: string
  open: boolean
  onClose: () => void
  onSuccess: () => void
}
const MfaResetModal: React.FC<Props> = ({
  name,
  memberId,
  open,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation()
  const { mutate, isPending, reset } = useResetMfa(memberId, onSuccess)
  const onResetMFA = (): void => {
    mutate({ id: memberId })
    toaster.create({
      title: t('pages.members.action.resetMfa.success'),
      type: 'success',
    })
    onSuccess()
  }

  return (
    <ModalView
      title={t('pages.members.action.resetMfa.title')}
      open={open}
      onClose={onClose}
      onExitComplete={reset}
      bodyChildren={
        <Text>
          {t('pages.members.action.resetMfa.description', { name: name })}
        </Text>
      }
      footerChildren={
        <>
          <TertiaryButton onClick={onClose}>
            {t('action.cancel')}
          </TertiaryButton>
          <PrimaryButton
            onClick={onResetMFA}
            loading={isPending}
            disabled={isPending}
            spinnerPlacement="start"
          >
            {t('pages.members.action.resetMfa.confirm')}
          </PrimaryButton>
        </>
      }
    />
  )
}

export default React.memo(MfaResetModal)
